export default {
  titles: {
    global: 'Global Settings',
    danger: 'Danger Zone',
    colors: 'Route Colors',
    sectors: 'Sectors',
    lanes: 'Lanes',
    memberships: 'Permissions',
    spot: "Group's spots",
    billing: 'Subscription and Invoicing',
  },
  global: {
    title: 'Setting up your spot',
    form: {
      name: 'Name of the spot',
      boulderScale: 'Boulder grading scale',
      routeScale: 'Route grading scale',
      floorPlan: 'Floor plan',
      floorPlanUpload: 'Upload an image',
      floorPlanProject: 'Open the floor plan editor',
      visible: 'Visible in search directory',
      anonymousComment: 'Allow comments without login',
      submit: 'Save',
      options: 'Options',
    },
    formHelper: {
      visible: 'Check this box to make the room visible in the search box on the https://verticaltopo.com page',
      anonymousComment: 'Check this box to allow user commenting the routes without having to be logged in',
    },
  },
  colors: {
    table: {
      name: 'label',
      colors: 'colors',
    },
    button: {
      add: 'New color',
    },
  },
  spots: {
    table: {
      name: 'label',
    },
    button: {
      add: 'New spot',
    },
  },
  sectors: {
    table: {
      name: 'label',
    },
    button: {
      add: 'New sector',
    },
  },
  lanes: {
    table: {
      name: 'label',
      sector: 'sector',
    },
    button: {
      add: 'New lane',
    },
  },
  memberships: {
    table: {
      user: 'member',
      role: 'role',
      roles: {
        admin: 'Admin',
        setter: 'Route Setter',
      },
    },
    button: {
      add: 'New member',
    },
  },
  delete: {
    title: 'Delete this spot',
    description: 'Once you delete a spot, there is no going back. Please be certain.',
    button: 'Delete this spot',
    confirm: {
      title: 'Are you absolutely sure?',
      warning: 'Warning',
      helper: 'This action cannot be undone. This will permanently delete the spot, the routes and the comments.',
      submit: 'Delete this spot',
    },
  },
  tooltip: {
    subscribed: 'deletion not allowed: active subscription',
  },
}
